var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fx-1 bgc-w of-a pt-20 pb-20 pl-20 pr-20"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.trainingDoc)}})])}
var staticRenderFns = []

export { render, staticRenderFns }